export default __webpack_public_path__ + "static/media/sem-produto-detalhe.b4670a76.png";